<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-12 mt-2 d-inline-block">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput" v-model="searchString">
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mt-2 text-center">
                    <button class="btn btn-primary" @click="onModalShow">مشاهده و ثبت موجودی اولیه</button>
                </div>
                <div class="col-12 col-md-4 mt-2 col-lg-2 text-center">
                    <button class="btn btn-primary" @click="onModalButtonClick">افزودن محصول</button>
                </div>
            </div>


        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0, noStock: item.stock < 1}" class="card list"
                     @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-6">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-2">
                            <span>موجودی: </span>
                            <span v-if="item.stock === undefined || item.stock === ''">0</span>
                            <span v-else>{{item.stock}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>تعداد: </span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                        </div>
                        <div class="col-md-4">
                            <span>قیمت: </span>
                            <span>{{item.sellPrice == null ? 0 :item.sellPrice.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0, noStock: item.stock < 1}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار:</span>
                            <span>{{item.stock}}</span>
                            <br>
                            <span>قیمت:</span>
                            <span>{{item.sellPrice == null ? 0 :item.sellPrice.toLocaleString()}}</span>
                            <br>
                            <span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                            <img class="view-image" :src="item.imageAddress!==null && item.imageAddress !='' ? validateImageUrl(item.imageAddress) :noImageUrl()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 mt-5 text-center" v-if="products !== undefined && products.length < 1">
                <h3 class="no-item-alert">محصولی یافت نشد!</h3>
            </div>
            <!--<div class="col-lg-12 mt-5"-->
            <!--:style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">-->
            <!--<div class="sk-circle" id="loading"-->
            <!--:style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">-->
            <!--<div class="sk-circle1 sk-child"></div>-->
            <!--<div class="sk-circle2 sk-child"></div>-->
            <!--<div class="sk-circle3 sk-child"></div>-->
            <!--<div class="sk-circle4 sk-child"></div>-->
            <!--<div class="sk-circle5 sk-child"></div>-->
            <!--<div class="sk-circle6 sk-child"></div>-->
            <!--<div class="sk-circle7 sk-child"></div>-->
            <!--<div class="sk-circle8 sk-child"></div>-->
            <!--<div class="sk-circle9 sk-child"></div>-->
            <!--<div class="sk-circle10 sk-child"></div>-->
            <!--<div class="sk-circle11 sk-child"></div>-->
            <!--<div class="sk-circle12 sk-child"></div>-->
            <!--</div>-->
            <!--</div>-->
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center my-3" @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر
                    ({{products.length}}/{{dataCount}})
                </button>
                <div class="col-2 offset-5 my-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تعداد نمایش</span>
                        </div>
                        <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                    </div>
                </div>
            </div>

            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات انتخاب شده</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th class=" text-nowrap">نام محصول</th>
                                        <th class="text-center text-nowrap">قیمت خرید</th>
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <th class="text-center text-nowrap">قیمت</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in cart">
                                        <td class="product-remove-button"><a class="text-danger"
                                                                             @click="onRemoveProductClicked(index)"><i
                                                class="fa fa-close"></i></a></td>
                                        <td class="text-nowrap">{{item.productName}}</td>
                                        <td class="text-center min-vw-100">
                                            <input class="form-control" style="min-width: 6rem;" type="number" v-model="item.price">
                                            <small class="text-nowrap mt-2">{{item.priceShow}}</small>
                                        </td>
                                        <td class="text-center">
                                            <input class="form-control" style="min-width: 4rem;" type="number" v-model="item.unitVal">
                                        </td>
                                        <td class="text-center">
                                            <input class="form-control" style="min-width: 6rem;" type="number" v-model="item.sellPrice">
                                            <small class="text-nowrap mt-2">{{item.sellPriceShow}}</small>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                    است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات">
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend " @click="toggleStartDatePicker">
                                    <div class="input-group-text"><span>تاریخ فاکتور :</span></div>
                                </div>
                                <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                             ref="datePickerStart" style="flex: 1">
                                    <slot>
                                        <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                               @click="toggleStartDatePicker">
                                        <button class="close reset-date" @click="resetStartDate">×</button>
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <div class="w-100 text-right">
                                <span>تعداد کل: </span>
                                <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                <span v-else>{{voucher.overallAmount}}</span>
                                &nbsp;&nbsp;&nbsp;
                                <span>مبلغ کل: </span>
                                <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                <span v-else>{{voucher.overallPrice.toLocaleString()}}</span>
                            </div>
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>

                            <button type="button" class="btn btn-success m-0" @click="onPaymentClicked"
                                    v-if="cart.length > 0">ثبت به عنوان موجودی اولیه
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitlepp">ایجاد
                                محصول</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>`
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته بندی</span>
                                        </div>
                                        <vs-select :data="categories" :selected-val="preselectedCategory"
                                                   :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onCategoryChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                    <button class="btn btn-primary bg-danger-grad border-0"
                                            @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                            title="افزودن دسته بندی">افزودن دسته بندی
                                    </button>
                                </div>
                                <div class="col-lg-12 mt-3 mt-lg-0">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">واحد</span>
                                        </div>
                                        <vs-select :data="units" :selected-val="preselectedUnit"
                                                   :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                                   @onChange="onUnitChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">بارکد</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="product.barcode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">تعداد هشدار کسر موجودی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.lessAmount">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد فنی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.technicalCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">شناسه مالیاتی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.taxCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">درصد مالیات</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.defultTaxPercent">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productCode">
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onProductModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger glow-warning">
                            <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row text-center">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">عنوان دسته بندی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="categoryName">
                                    </div>
                                </div>
                                <!--<div class="col-lg-6 mb-2">-->
                                <!--<div class="input-group">-->
                                <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">دسته بندی مادر</span>-->
                                <!--</div>-->
                                <!--<vs-select-->
                                <!--:data="categories"-->

                                <!--:mode="'create'"-->
                                <!--:header="{multiple: false, label: 'name'}"-->
                                <!--@onChange="onCategoryChange"-->
                                <!--&gt;</vs-select>-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import EventBus from "../../_framework/event-bus.js";
    import VsSelect from '../../_framework/VsSelect.vue';
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from "moment-jalali";


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'initial-product',
        components: {
            VsSelect,
            DatePicker
        },
        data() {
            return {
                barcodeInputTimeout: null,
                products: [],
                categories: [],
                units: [],
                preselectedCategory: {},
                categoryName: "",
                preselectedUnit: {},
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    showAll: false,

                },
                searchString: "",
                modalProductName: "",
                cart: [],
                voucher: {
                    description: "",
                    receiveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0,
                    voucherDate: "0001-01-01",
                },
                voucherDatePersian: "",
                tempVoucher: [],
                outSourceName: "",
                dataCount: 0,

                listView: false,
                autoload: false,

                userId: 0,
                companyId: 0,
                fromEdit: false,
                isSending: false,
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    categoryId: 0,
                    productImages: []
                },
            }
        },
        mounted() {
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });

            if (localStorage.getItem("auth_token") === null) {
                this.$noty.error('لطفا مجددا وارد شوید!');
                this.$router.push({name: 'login'});
            } else {
                // this.queryParams.companyId = this.companyId;
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.$route.params.voucher !== undefined) {
                        this.cart = this.$route.params.voucher.voucherProductDto;
                        this.voucher.description = this.$route.params.voucher.description;
                        this.validateProductsList();
                    }
                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            }


            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts(-1);

                    }
                });
            }


            if (localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`) === null) {
                localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, "[]");
            }


            this.getCategories();
            this.getUnits();
            this.$refs.searchInput.focus();
        },
        methods: {
            changePageSize(e) {
                this.getProducts(-1);
            },
            getUnits() {
                new BaseService('units').getAll().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });

            },
            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.products = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                // $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    this.dataCount = response.data.count;
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onSearchInput() {
                if (this.barcodeInputTimeout) {
                    clearTimeout(this.barcodeInputTimeout);
                }
                this.barcodeInputTimeout = setTimeout(() => {
                    this.queryParams.name = this.searchString;
                    this.queryParams.pageIndex = 0;
                    let queryParams2 = {
                        name: this.searchString,
                        showAll: false,
                        pageSize: 18,
                        pageIndex: 0,
                    };
                    $("#loading").hide();
                    new BaseService('product').getList(queryParams2).then(response => {
                        this.products = response.data.data;
                        this.validateProductsList();
                        $("#loading").hide();
                    }).catch(error => {
                        $("#loading").hide();
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });

                }, 300);
            },
            validateProductsList() {
                for (let item of this.cart) {
                    for (let product of this.products) {
                        if (item.productName === product.productName) {
                            product.unitVal = item.unitVal;
                            product.price = item.salesPrice;
                        }
                    }
                }
            },
            onCardClicked(e, index) {
                let flag = false;
                let i = 0;
                let offset = 0;
                for (let item of this.cart) {
                    if (item.productName === this.products[index].productName) {
                        flag = true;
                        offset = i;
                    }
                    i++;
                }
                if (flag === false) {
                    this.products[index].unitVal++;
                    Vue.set(this.products[index], "originalPrice", this.products[index].price);
                    Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                    this.cart.push(this.products[index]);
                } else {
                    this.cart[offset].unitVal++;
                    //this.products[index].unitVal++;
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalShow() {
                $("#voucherData").modal("show");
                // console.log(this.cart)
            },
            onModalOk() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        item.price = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    if (this.$route.params.voucher !== undefined) {
                        let desc = this.voucher.description;
                        this.voucher = this.$route.params.voucher;
                        this.voucher.description = desc;
                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`));
                        this.tempVoucher[this.voucher.voucherIndex] = this.voucher;
                        localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    } else {
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;

                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`));
                        this.tempVoucher.push(this.voucher);
                        localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    }

                    $("#voucherData").modal("hide");
                    this.$noty.info("فاکتور ذخیره شد. برای تکمیل عملیات به بخش بایگانی، فاکتورهای باز مراجعه کنید.");
                    for (let item of this.products) {
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

                /*new BaseService('voucher').create(this.voucher).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })*/
            },
            onPaymentClicked() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null || this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                            for (let item of this.cart) {
                                item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                                item.salesPrice = item.sellPrice === null ? 0 : parseInt(item.sellPrice);
                                item.price = item.price === null ? 0 : parseInt(item.price);
                                // item.price = item.salesPrice;
                                Vue.set(item, "productId", item.id);
                            }
                            this.voucher.voucherProductDto = this.cart;
                            // this.voucher.receiveOutSourceId = parseInt(this.queryParams.outsourceId);
                            // this.voucher.outSourceName = this.outSourceName;
                            $("#voucherData").modal("hide");

                            new BaseService('Voucher', '/OpeningProduct').create(this.voucher).then(response => {
                                let obj = {
                                    name: 'home',
                                };
                                this.$router.push(obj);
                                this.isSending = false;
                            }).catch(error => {
                                this.isSending = false;
                                console.log(error)
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            });
                        }
                    } else {
                        this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                    }
                }

            },
            calculateOverallAmount() {
                let amount = 0;
                for (let item of this.cart) {
                    amount += parseFloat(item.unitVal);
                }
                this.voucher.overallAmount = amount;
            },
            calculateOverallPrice() {
                let price = 0;
                for (let item of this.cart) {
                    price += (parseFloat(item.unitVal) * parseInt(item.price));
                    item.sellPriceShow = this.thousandSeprator3(item.sellPrice);
                    item.priceShow = this.thousandSeprator3(item.price);
                }
                this.voucher.overallPrice = price;
            },
            onReturn() {
                if (confirm("در صورت تایید اطلاعات پرداخت فروش و کالاهای آن حذف میشوند. آیا مرجوعی را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {


                        let obj = {
                            name: 'home',

                        };
                        this.$router.push(obj);
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onModalButtonClick() {
                $("#productModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }
                this.product.productImages = [];
                this.documentList = null;
                this.helpDocumentModel = null;
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // this.$router.push({name: 'category'});
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onProductModalOk() {
                this.onCreateProduct(this.product);
            },
            onCreateProduct(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#productModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                this.dataCount = response.data.count;
                                $("#loading").hide();
                            }).catch(error => {
                                $("#loading").hide();
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            thousandSeprator3(a) {
                let amount = a;
                let showprice = "";

                if (amount !== '' && amount !== undefined && amount !== 0 && amount !== '0' && amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a = showprice;
                return a;
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.voucher.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.voucher.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
        watch: {
            cart: {
                handler(val) {
                    this.calculateOverallAmount();
                    this.calculateOverallPrice();
                },
                deep: true
            }
        }
    }
</script>